/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_Regions_DescriptionInputs */

const en_manage_regions_description = /** @type {(inputs: Manage_Regions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add, edit, or remove coffee regions.`)
};

const es_manage_regions_description = /** @type {(inputs: Manage_Regions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrega, edita o elimina regiones de cafe.`)
};

/**
* | output |
* | --- |
* | "Add, edit, or remove coffee regions." |
*
* @param {Manage_Regions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const manage_regions_description = /** @type {((inputs?: Manage_Regions_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_Regions_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_regions_description(inputs)
	return es_manage_regions_description(inputs)
});